import { ExpressionActionTypeEnum } from './action-type';
import { ExpressionTypeEnum } from './expression-type';
import { z } from 'zod/v4';

/** ExpressionAction */
export const ExpressionActionDTO = z.object({
  /** @default "LITERAL" */
  type: z.nativeEnum(ExpressionActionTypeEnum).optional(),
  /** значение для записи */
  value: z.string(),
});
export type ExpressionAction = z.infer<typeof ExpressionActionDTO>;

/** Expression */
export const ExpressionDTO = z.object({
  name: z.string(),
  /** тип атрибута LDAP */
  type: z.nativeEnum(ExpressionTypeEnum),
  /** выражение для поиска значения атрибута */
  expression: z.string().optional(),
  /** значение при правильном совпадении */
  true_action: ExpressionActionDTO.optional(),
  /** значение при несовпадении */
  false_action: z.any().optional(),
  /** @default false — флаг использования атрибута для синхронизации */
  active: z.boolean().optional(),
});
export type Expression = z.infer<typeof ExpressionDTO>;

/** ExpressionEager */
export const ExpressionEagerDTO = ExpressionDTO.extend({
  label: z.string(),
});
export type ExpressionEager = z.infer<typeof ExpressionEagerDTO>;

/** ExtendedAttributeExpression (ExtendedExpressionDTO) */
export const ExtendedExpressionDTO = ExpressionDTO.extend({
  /** идентификатор типа атрибута (базовый или расширенный) */
  attr_type: z.enum(['base', 'extended']).optional(),
  label: z.string(),
});
export type ExtendedExpression = z.infer<typeof ExtendedExpressionDTO>;

/** ExtendedExpressionEagerDTO */
export const ExtendedExpressionEagerDTO = ExpressionEagerDTO.extend({
  attr_type: z.enum(['base', 'extended']).optional(),
});
export type ExtendedExpressionEager = z.infer<
  typeof ExtendedExpressionEagerDTO
>;